import React from 'react'
import { CrudPageContent } from '@morningtrain/react-crud'
import * as Fields from 'support/fields'
import { Fieldset } from 'layouts'
import EditLayout from 'layouts/crud/EditLayout'
import EditFormActions from 'layouts/crud/EditFormActions'
import FormCard from 'ui/cards/FormCard'
import Title from 'layouts/page/Title'
import { WhenModelValue, WhenCaseIs } from '@morningtrain/react-resources'
import IntegerConverterField from 'support/fields/IntegerConverterField'

export default class Edit extends CrudPageContent {
  get resourceName () {
    return 'customers'
  }

  get layout () {
    return EditLayout
  }

  get actions () {
    return <EditFormActions />
  }

  get fields () {
    return (
      <FormCard header={<Title />}>
        <Fieldset cols={2}>
          <Fields.Input name='customer_number' label='Kundenr' />
          <Fields.Input name='name' label='Navn' />
          <Fields.Input name='email' label='E-mail' />
          <Fields.Input name='cvr' label='CVR' />
          <Fields.Input name='address' label='Adresse' />
          <Fieldset cols={2}>
            <Fields.Input name='city' label='By' />
            <Fields.Input name='zipcode' label='Postnr' />
          </Fieldset>
          <Fields.Hidden name='contact.id' />
          <Fieldset>
            <Fieldset label='Kontaktperson' cols={2}>
              <Fields.Input name='contact.name' label='Navn' />
              <Fields.Input name='contact.email' label='E-mail' />
              <Fields.Hidden name='contact.role_name' defaultValue='customer' />
            </Fieldset>

            <Fieldset label='Fastpris' cols={2}>
              <IntegerConverterField name='fixed_price_override' label='Fastpris beløb i kr.' step={0.01} min={0.01} defaultValue={0} />
              <Fields.Blank />
            </Fieldset>

            <Fieldset label='Rabat' cols={2}>
              <Fields.Switch
                label='Rabat type'
                name='discount_type'
                enum='discount_types'
                defaultValue='fixed'
                placeholder='Vælg rabat type'
              >

                <WhenCaseIs value='fixed'>
                  <IntegerConverterField name='discount_amount' label='Rabat beløb i kr.' step={0.01} min={0.01} defaultValue={0} />
                </WhenCaseIs>
                <WhenCaseIs value='percentage'>
                  <Fields.Input name='discount_amount' label='Rabat i %' />
                </WhenCaseIs>

              </Fields.Switch>
            </Fieldset>
          </Fieldset>
        </Fieldset>
      </FormCard>
    )
  }
}
